import script from "./LegalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalModal.vue?vue&type=script&setup=true&lang=js"

import "./LegalModal.vue?vue&type=style&index=0&id=604d396c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604d396c"]])

export default __exports__